import FieldReferenceIdAndKeyDto from "../../../dtos/FieldReferenceIdAndKeyDto";
import PathReportingMappingCapabilitiesDto from "../../../dtos/pathreportingmodule/PathReportingMappingCapabilitiesDto";
import TransformationCapabilitiesDto from "../../../dtos/transformationmodule/TransformationCapabilitiesDto";

class GetPathReportingCapabilitiesResult {
    SourceFields: FieldReferenceIdAndKeyDto[];
    MappingsCapabilities: PathReportingMappingCapabilitiesDto[];
    TransformationsCapabilities: TransformationCapabilitiesDto[]; 

    constructor(sourceFields: FieldReferenceIdAndKeyDto[], mappingsCapabilities: PathReportingMappingCapabilitiesDto[], transformationCapabilities: TransformationCapabilitiesDto[]) {
        this.SourceFields = sourceFields;
        this.MappingsCapabilities = mappingsCapabilities;
        this.TransformationsCapabilities = transformationCapabilities;
    }
}

export default GetPathReportingCapabilitiesResult;
